import { DecimalPipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { TradableProductsBase } from '@zero/search/feature-tradable-products/base';
import { InstrumentDetailsLinkComponent } from '@zero/shared/ui-web-components';
import { AssetSearchService } from '@zero/shared/util-services';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  templateUrl: './tradable-products.component.html',
  styleUrls: ['./tradable-products.component.scss'],
  imports: [FormsModule, InstrumentDetailsLinkComponent, RouterLink, DecimalPipe, TranslocoPipe],
})
export class TradableProductsComponent extends TradableProductsBase implements OnInit, OnDestroy {
  public readonly commonRoutes = commonRoutes;

  constructor(
    protected override route: ActivatedRoute,
    public override service: AssetSearchService,
  ) {
    super(route, service);
  }
}
